// src/design-system/layout/PageContainer.tsx
import type { ReactNode } from "react";

export function PageContainer({ children }: { children: ReactNode }) {
  return <div className="space-y-6">{children}</div>;
}